export default {
  isLoading: false,
  listaCentros: [],
  listaCentrosFiltrados: [],
  filtrosCentros: null,
  isOpenModalEditar: false,
  isOpenModalEliminar: false,
  isOpenModalDesactivar: false,
  centro: {},
  isNewCentro: false,
  listaPools: [],
  listaAdditionalExams: [],
  listaPsychologicalExams: [],
  listaTerritorios: [],
};
